<!-- #################### OLD MAIN VIEW #################### -->
<div *ngIf="!sidebar">
	<div
		class="filterWrapper old d-flex"
		[ngClass]="{
			'activeOperation': !showBody() && hasAppliedFilter(),
			'isOpen': showBody()
			}"
	>

		<div
			class="d-flex flex-grow-1"
			[ngClass]="{ 'active': hasAppliedFilter() }"
		>
			<i
				class="operator-icon fa fa-filter vertical-separator--right"
				(click)="toggleBodyVisibility()"
			></i>

			<div
				class="operator-title"
				(click)="toggleBodyVisibility()"
			>
				<span>{{ getI18nString( false, 'shared.listOperations.filter' ) }}</span>
			</div>

			<span
				class="resetAll"
				(click)="clearAllFilter(); $event.stopPropagation()"
			>
				{{ getI18nString( false, 'shared.listOperations.resetAllClear' )  }}
			</span>
		</div>

		<div class="operator-body d-flex flex-column mx-0 pe-0">
			<div class="filterItemsWrapper ps-0">
				<ng-container *ngFor="let filter of filterData">
					<div
						*ngIf="filter.isRendered"
						class="filterWrapper mt-3"
						[ngClass]="{ 'disabled': filter.isDisabled }"
						[ngSwitch]="filter.type"
					>

						<div class="row filter-info">

							<!-- Filter Label -->
							<div
								class="align-self-center"
								[ngClass]="filter.type === filterTypes.FILTER_SWITCH_TYPE ? 'col-7 pe-0' : 'col'"
							>
								{{ getI18nString( false, filter?.i18nPath + '.label' )  }}
							</div>

							<!-- FILTER_SWITCH_TYPE -->
							<ng-container
								*ngSwitchCase="filterTypes.FILTER_SWITCH_TYPE"
								[ngTemplateOutletContext]="{filter:filter}"
								[ngTemplateOutlet]="filterSwitchTpl">
							</ng-container>

							<!-- Filter Reset -->
							<div
								*ngIf="filter.type !== filterTypes.FILTER_TEXT_TYPE"
								class="col-auto align-self-center reset"
								(click)="clearFilter( filter )"
							>
								{{ getI18nString( false, 'shared.listOperations.resetSpecificClear' )  }}
							</div>
						</div>

						<!-- ALL REMAINING FILTER TYPES -->
						<ng-container
							[ngTemplateOutletContext]="{filter:filter}"
							[ngTemplateOutlet]="filterSwitchCaseTpl">
						</ng-container>
					</div>
				</ng-container>
			</div>

			<!-- Action Buttons -->
			<div class="pt-2 pb-0 border-top filter-buttons">
				<div class="text-center px-0">
					<button
						class="btn abortBtn my-2 me-2"
						(click)="showBody.set(!showBody())"
					>
						{{ getI18nString( false, 'shared.listOperations.close' ) }}
					</button>

					<button
						class="btn my-2"
						(click)="emitFilterChanges()"
					>
						{{ getI18nString( false, 'shared.listOperations.apply' ) }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- #################### NEW MAIN VIEW #################### -->
<div *ngIf="sidebar" class="filterWrapper sidebar">

	<div class="d-flex flex-grow-1">
		<i class="operator-icon fa fa-filter vertical-separator--right"></i>

		<div class="operator-title">
			<span>{{ getI18nString( false, 'shared.listOperations.filter' ) }}</span>
		</div>

		<span
			class="resetAll"
			(click)="clearAllFilter(); $event.stopPropagation()"
		>{{ getI18nString( false, 'shared.listOperations.resetAllClear' ) }}</span>
	</div>

	<div class="operator-body row mx-0 pe-0">
		<div class="filterItemsWrapper col-12 ps-0">
			<ng-container *ngFor="let filter of filterData">
				<div
					*ngIf="filter.isRendered"
					class="filterWrapper mt-3"
					[ngClass]="{ 'disabled': filter.isDisabled }"
					[ngSwitch]="filter.type"
				>

					<div class="row filter-info">

						<!-- Filter Label -->
						<div
							class="align-self-center"
							[ngClass]="filter.type === filterTypes.FILTER_SWITCH_TYPE ? 'col-auto' : 'col'"
						>
							{{ getI18nString( false, filter?.i18nPath + '.label' )  }}
						</div>

						<!-- FILTER_SWITCH_TYPE -->
						<ng-container
							*ngSwitchCase="filterTypes.FILTER_SWITCH_TYPE"
							[ngTemplateOutletContext]="{filter:filter}"
							[ngTemplateOutlet]="filterSwitchTpl">
						</ng-container>

						<!-- Filter Resets -->
						<div
							class="col-auto align-self-center"
						>
							<!-- Filter Clear -->
							<span
								*ngIf="filter.type !== filterTypes.FILTER_TEXT_TYPE"
								class="reset"
								(click)="clearFilter( filter )"
							>
								{{ getI18nString( false, 'shared.listOperations.resetSpecificClear' )  }}
							</span>

							<!-- Filter Reset To Default -->
							<span
								class="ms-1 reset"
								(click)="resetFilter( filter, listOperationsResetMode.DEFAULT )"
							>
								{{ getI18nString( false, 'shared.listOperations.resetSpecificToDefault' ) }}
							</span>

							<!-- Filter Restore To Previous -->
							<span
								class="ms-1 reset"
								(click)="resetFilter( filter, listOperationsResetMode.RESTORE )"
							>
								{{ getI18nString( false, 'shared.listOperations.resetSpecificToPrevious' ) }}
							</span>
						</div>
					</div>

					<!-- ALL REMAINING FILTER TYPES -->
					<ng-container
						[ngTemplateOutletContext]="{filter:filter}"
						[ngTemplateOutlet]="filterSwitchCaseTpl">
					</ng-container>
				</div>
			</ng-container>
		</div>
	</div>
</div>

<!-- ######################### TEMPLATES ######################### -->
<!-- FilterSwitchCaseTpl -->
<ng-template #filterSwitchCaseTpl let-filter="filter">
	<div
		class="filterItemsWrapper mt-1 px-0"
		[ngSwitch]="filter.type"
	>

		<!-- FilterDatepickerType	-->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_DATE_PICKER_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterDatepickerTpl">
		</ng-container>

		<!-- FilterDateRangePickerType	-->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_DATE_RANGE_PICKER_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterDateRangePickerTpl">
		</ng-container>

		<!-- FilterListType	-->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_LIST_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterListTpl">
		</ng-container>

		<!-- FilterOptionTpl -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_OPTION_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterOptionTpl">
		</ng-container>

		<!-- FilterSelectArchivingErsType -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_ARCHIVING_ERS_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectArchivingErsTpl">
		</ng-container>

		<!-- FilterSelectArchivingKeywordType -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_ARCHIVING_KEYWORD_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectArchivingKeywordTpl">
		</ng-container>

		<!-- FilterSelectArchivingTssType -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_ARCHIVING_TSS_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectArchivingTssTpl">
		</ng-container>

		<!-- FilterSelectBusinessPremisesType -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_BUSINESS_PREMISES_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectBusinessPremisesTpl">
		</ng-container>

		<!-- FilterSelectContractType -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_CONTRACT_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectContractTpl">
		</ng-container>

		<!-- FilterSelectErsType -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_ERS_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectErsTpl">
		</ng-container>

		<!-- FilterSelectOrganizationType	-->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_ORGANIZATION_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectOrganizationTpl">
		</ng-container>

		<!-- FilterSelectStaticItemsType -->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_STATIC_ITEMS_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectStaticItemsTpl">
		</ng-container>

		<!-- FilterSelectTenantType	-->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_TENANT_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectTenantTpl">
		</ng-container>

		<!-- FilterSelectTssType	-->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_SELECT_TSS_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterSelectTssTpl">
		</ng-container>

		<!-- FilterTextType	-->
		<ng-container
			*ngSwitchCase="filterTypes.FILTER_TEXT_TYPE"
			[ngTemplateOutletContext]="{filter:filter}"
			[ngTemplateOutlet]="filterTextTpl">
		</ng-container>
	</div>
</ng-template>

<!-- FilterDatepickerTpl -->
<ng-template #filterDatepickerTpl let-filter="filter">
	<app-datepicker-filter
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, { param: $event })"
	></app-datepicker-filter>
</ng-template>

<!-- FilterDateRangePickerTpl -->
<ng-template #filterDateRangePickerTpl let-filter="filter">
	<app-date-range-picker-filter
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, { param: $event })"
	></app-date-range-picker-filter>
</ng-template>

<!-- FilterListTpl -->
<ng-template #filterListTpl let-filter="filter">
	<app-list-filter
		[defaultFilterData]="filter"
		[listOperationIdentifier]="listOperationIdentifier"
		[sidebar]="sidebar"
		(filterItemChange)="onFilterItemChange(filter, $event)"
	></app-list-filter>
	<!-- TODO remove 'sidebar' binding after list ops re-working is done! -->
</ng-template>

<!-- FilterOptionTpl -->
<ng-template #filterOptionTpl let-filter="filter">
	<app-option-filter
		[defaultFilterData]="filter"
		[listOperationIdentifier]="listOperationIdentifier"
		(filterItemChange)="onFilterItemChange(filter, $event)"
	></app-option-filter>
</ng-template>

<!-- FilterSelectArchivingErsTpl -->
<ng-template #filterSelectArchivingErsTpl let-filter="filter">
	<app-select-filter-archiving-ers
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event)"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-archiving-ers>
</ng-template>

<!-- FilterSelectArchivingKeywordTpl -->
<ng-template #filterSelectArchivingKeywordTpl let-filter="filter">
	<app-select-filter-archiving-keyword
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event)"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-archiving-keyword>
</ng-template>

<!-- FilterSelectArchivingTssTpl -->
<ng-template #filterSelectArchivingTssTpl let-filter="filter">
	<app-select-filter-archiving-tss
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event )"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-archiving-tss>
</ng-template>

<!-- FilterSelectBusinessPremisesTpl -->
<ng-template #filterSelectBusinessPremisesTpl let-filter="filter">
	<app-select-filter-business-premises
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event )"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-business-premises>
</ng-template>

<!-- FilterSelectContractTpl -->
<ng-template #filterSelectContractTpl let-filter="filter">
	<app-select-filter-contract
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event )"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-contract>
</ng-template>

<!-- FilterSelectErsTpl -->
<ng-template #filterSelectErsTpl let-filter="filter">
	<app-select-filter-ers
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event)"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-ers>
</ng-template>

<!-- FilterSelectOrganizationTpl -->
<ng-template #filterSelectOrganizationTpl let-filter="filter">
	<app-select-filter-organization
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event)"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-organization>
</ng-template>

<!-- FilterSelectStaticItemsTpl -->
<ng-template #filterSelectStaticItemsTpl let-filter="filter">
	<app-select-filter-items
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event)"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-items>
</ng-template>

<!-- FilterSelectTenantTpl -->
<ng-template #filterSelectTenantTpl let-filter="filter">
	<app-select-filter-tenant
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event)"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-tenant>
</ng-template>

<!-- FilterSelectTssTpl -->
<ng-template #filterSelectTssTpl let-filter="filter">
	<app-select-filter-tss
		[defaultFilterData]="filter"
		[shouldReset]="resetEventEmitter.asObservable()"
		(change)="onFilterItemChange(filter, $event)"
		(filterIsInitialized)="onAsyncFilterInit($event)"
	></app-select-filter-tss>
</ng-template>

<!-- FilterSwitchTpl -->
<ng-template #filterSwitchTpl let-filter="filter">
	<app-switch-filter
		class="d-inline-flex align-self-center col px-0"
		[defaultFilterData]="filter"
		[listOperationIdentifier]="listOperationIdentifier"
		(filterItemChange)="onFilterItemChange(filter, $event)"
	></app-switch-filter>
</ng-template>

<!-- FilterTextTpl -->
<ng-template #filterTextTpl let-filter="filter">
	<app-text-filter
		[defaultFilterData]="filter"
		[listOperationIdentifier]="listOperationIdentifier"
		[sidebar]="sidebar"
		(filterItemChange)="onFilterItemChange(filter, $event)"
	></app-text-filter>
</ng-template>
